import { FormTypeId } from '~/common/constants/formTypes'
import type { Config } from '~/form/types'

import {
  default as BACK_OFFICE,
  validators as validatorBackOffice,
} from './BACK_OFFICE'
import {
  default as BAKUSOKU,
  validators as validatorsBakusoku,
} from './BAKUSOKU'
import {
  default as CAPITALIST,
  validators as validatorCapitalist,
} from './CAPITALIST'
import {
  default as CG_DESIGNER,
  validators as validatorCgDesigner,
} from './CG_DESIGNER'
import {
  default as CONSULTANT,
  validators as validatorsConsultant,
} from './CONSULTANT'
import {
  default as CREATIVE,
  validators as validatorsCreative,
} from './CREATIVE'
import {
  default as CREATIVE_PART_TIMER,
  validators as validatorsCreativePartTimer,
} from './CREATIVE_PART_TIMER'
import {
  default as CREATIVE_W_PORTFOLIO,
  validators as validatorsCreativeWithPortfolio,
} from './CREATIVE_W_PORTFOLIO'
import {
  default as CUSTOMER_SUCCESS,
  validators as validatorCustomerSuccess,
} from './CUSTOMER_SUCCESS'
import {
  default as DESIGNER,
  validators as validatorDesigner,
} from './DESIGNER'
import { default as FINANCE, validators as validatorsFinance } from './FINANCE'
import {
  default as GENERAL_PART_TIMER,
  validators as validatorsGeneralPartTimer,
} from './GENERAL_PART_TIMER'
import {
  default as HUMAN_RESOURCES,
  validators as validatorsHumanResources,
} from './HUMAN_RESOURCES'
import {
  default as ILLUSTRATOR,
  validators as validatorsIllustrator,
} from './ILLUSTRATOR'
import {
  default as INSIDE_SALES,
  validators as validatorsInsideSales,
} from './INSIDE_SALES'
import { default as LEVEL1, validators as validatorsLv1 } from './LEVEL1'
import { default as LEVEL2, validators as validatorsLv2 } from './LEVEL2'
import { default as LEVEL3, validators as validatorsLv3 } from './LEVEL3'
import { default as LEVEL4, validators as validatorsLv4 } from './LEVEL4'
import { default as LIGHT, validators as validatorsLight } from './LIGHT'
import {
  default as LIGHT_BAKUSOKU,
  validators as validatorsLightBakusoku,
} from './LIGHT_BAKUSOKU'
import {
  default as MARKETTER,
  validators as validatorMarketter,
} from './MARKETTER'
import {
  default as MOTION_GRAPHER,
  validators as validatorMotionGrapher,
} from './MOTION_GRAPHER'
import {
  default as PHOTOGRAPHER,
  validators as validatorPhotographer,
} from './PHOTOGRAPHER'
import {
  default as PLANNING,
  validators as validatorsPlanning,
} from './PLANNING'
import {
  default as PRODUCER,
  validators as validatorProducer,
} from './PRODUCER'
import {
  default as PRODUCTION_MANAGER,
  validators as validatorsProductionManager,
} from './PRODUCTION_MANAGER'
import {
  default as PROGRAMMER,
  validators as validatorsProgrammer,
} from './PROGRAMMER'
import {
  default as PROJECT_MANAGER,
  validators as validatorsProjectManager,
} from './PROJECT_MANAGER'
import {
  default as PROMOTION,
  validators as validatorsPromotion,
} from './PROMOTION'
import {
  default as REGISTER,
  validators as validatorsRegister,
} from './REGISTER'
import { default as REPOST, validators as validatorRepost } from './REPOST'
import {
  default as RESEARCHER,
  validators as validatorsResearcher,
} from './RESEARCHER'
import { default as SALES, validators as validatorsSales } from './SALES'
import {
  default as SELF_RECOMMENDED,
  validators as validatorsSelfRecommended,
} from './SELF_RECOMMENDED'
import {
  default as UI_UX_DESIGNER,
  validators as validatorsUiUx,
} from './UI_UX_DESIGNER'
import {
  default as VIDEO_DIRECTOR,
  validators as validatorsVideoDirector,
} from './VIDEO_DIRECTOR'
import {
  default as VIDEO_EDITOR,
  validators as validatorsVideoEditor,
} from './VIDEO_DIRECTOR'
import {
  default as WEB_DESIGNER,
  validators as validatorsWebDesigner,
} from './WEB_DESIGNER'
import {
  default as WEB_DIRECTOR,
  validators as validatorsWebDirector,
} from './WEB_DIRECTOR'
import { default as WRITER, validators as validatorWriter } from './WRITER'

type DefaultProps = { [key in FormTypeId]?: Config[] }

type Validator = {
  [key in FormTypeId]?: any
}

const configs: DefaultProps = {
  LIGHT,
  LIGHT_BAKUSOKU,
  BAKUSOKU,
  LEVEL4,
  LEVEL3,
  LEVEL2,
  LEVEL1,
  CREATIVE_PART_TIMER,
  CREATIVE_W_PORTFOLIO,
  CREATIVE,
  GENERAL_PART_TIMER,
  SALES,
  BACK_OFFICE,
  PROGRAMMER,
  PHOTOGRAPHER,
  WRITER,
  VIDEO_EDITOR,
  VIDEO_DIRECTOR,
  MOTION_GRAPHER,
  CG_DESIGNER,
  DESIGNER,
  PRODUCER,
  PRODUCTION_MANAGER,
  PROJECT_MANAGER,
  SELF_RECOMMENDED,
  MARKETTER,
  CUSTOMER_SUCCESS,
  UI_UX_DESIGNER,
  ILLUSTRATOR,
  WEB_DIRECTOR,
  WEB_DESIGNER,
  PROMOTION,
  PLANNING,
  HUMAN_RESOURCES,
  INSIDE_SALES,
  RESEARCHER,
  CONSULTANT,
  FINANCE,
  CAPITALIST,
  REPOST,
  REGISTER,
}

export const validators: Validator = {
  LIGHT: validatorsLight,
  LIGHT_BAKUSOKU: validatorsLightBakusoku,
  BAKUSOKU: validatorsBakusoku,
  LEVEL4: validatorsLv4,
  LEVEL3: validatorsLv3,
  LEVEL2: validatorsLv2,
  LEVEL1: validatorsLv1,
  CREATIVE_PART_TIMER: validatorsCreativePartTimer,
  CREATIVE_W_PORTFOLIO: validatorsCreativeWithPortfolio,
  CREATIVE: validatorsCreative,
  GENERAL_PART_TIMER: validatorsGeneralPartTimer,
  SALES: validatorsSales,
  BACK_OFFICE: validatorBackOffice,
  PROGRAMMER: validatorsProgrammer,
  PHOTOGRAPHER: validatorPhotographer,
  WRITER: validatorWriter,
  VIDEO_EDITOR: validatorsVideoEditor,
  VIDEO_DIRECTOR: validatorsVideoDirector,
  MOTION_GRAPHER: validatorMotionGrapher,
  CG_DESIGNER: validatorCgDesigner,
  DESIGNER: validatorDesigner,
  PRODUCER: validatorProducer,
  PRODUCTION_MANAGER: validatorsProductionManager,
  PROJECT_MANAGER: validatorsProjectManager,
  SELF_RECOMMENDED: validatorsSelfRecommended,
  MARKETTER: validatorMarketter,
  CUSTOMER_SUCCESS: validatorCustomerSuccess,
  UI_UX_DESIGNER: validatorsUiUx,
  ILLUSTRATOR: validatorsIllustrator,
  WEB_DIRECTOR: validatorsWebDirector,
  WEB_DESIGNER: validatorsWebDesigner,
  PROMOTION: validatorsPromotion,
  PLANNING: validatorsPlanning,
  HUMAN_RESOURCES: validatorsHumanResources,
  INSIDE_SALES: validatorsInsideSales,
  RESEARCHER: validatorsResearcher,
  CONSULTANT: validatorsConsultant,
  FINANCE: validatorsFinance,
  CAPITALIST: validatorCapitalist,
  REPOST: validatorRepost,
  REGISTER: validatorsRegister,
}

export default configs
